import { WebClient } from 'react-auth0rize'

export default new WebClient({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirectUri: '/callback',
  scope: 'openid profile email',
  storageKey: 'BAF:UI:auth',
})
